/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:53:01]
Permissions to update outside the main branch: [false]
*/

import { DropdownFilterButton } from '@finbeat/react-toolkit';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { usePrescrWorkplaceState } from './Prescr';

type PrescrAddButtonProps = {
    showModal: () => void;
};

const PrescrAddButton = ({ showModal }: PrescrAddButtonProps) => {
    const { setSelectedItem: setCurrentItem } = usePrescrWorkplaceState();

    return (
        <DropdownFilterButton
            onClick={() => {
                setCurrentItem(null);
                showModal();
            }}
            icon={faPlus}
            disabled={false}
            title="BackOfficeAdd"
        />
    );
};

export default PrescrAddButton;
